/* eslint-disable comma-dangle, quote-props, quotes */
export default {
  "link": [
    {
      "rel": "apple-touch-icon",
      "sizes": "180x180",
      "href": "/build/favicons/apple-touch-icon.png"
    },
    {
      "rel": "icon",
      "type": "image/png",
      "href": "/build/favicons/favicon-32x32.png",
      "sizes": "32x32"
    },
    {
      "rel": "icon",
      "type": "image/png",
      "href": "/build/favicons/favicon-16x16.png",
      "sizes": "16x16"
    },
    {
      "rel": "manifest",
      "href": "/build/favicons/manifest.json"
    },
    {
      "rel": "mask-icon",
      "href": "/build/favicons/safari-pinned-tab.svg",
      "color": "#cd4032"
    },
    {
      "rel": "shortcut icon",
      "href": "/build/favicons/favicon.ico"
    }
  ],
  "meta": [
    {
      "name": "apple-mobile-web-app-title",
      "content": "Stadyum CRM"
    },
    {
      "name": "application-name",
      "content": "Stadyum CRM"
    },
    {
      "name": "msapplication-TileColor",
      "content": "#cd4032"
    },
    {
      "name": "msapplication-TileImage",
      "content": "/build/favicons/mstile-144x144.png"
    },
    {
      "name": "msapplication-config",
      "content": "/build/favicons/browserconfig.xml"
    },
    {
      "name": "theme-color",
      "content": "#000000"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/common/app/favicon.js